<template>
    <div id="app">
        <Header/>
        <div class="pages">
            <!--<div v-if="$auth.ready()">-->
            <router-view/>
        </div>
        <Footer/>
        <v-dialog/>
        <member-info-modal/>
    </div>
</template>
<script>
    // @ is an alias to /src
    import Header from '@/components/common/Header.vue'
    import Footer from '@/components/common/Footer.vue'
    import moment from 'moment';
    import MemberInfoModal from '@/components/MemberInfoModal.vue'

    export default {
        name: 'app',
        components: {
            Header, Footer, MemberInfoModal
        },
        data() {
            return {
                category: [],
                level: [{level: 0, min: 0, max: 100000}],
                specialities: []
            }
        },
        methods: {
            commonDialog(title, msg) {
                this.$modal.show('dialog', {
                    title: title,
                    text: msg
                })
            },
            dateFormat(date, format) {
                return moment(date).format(format);
            },
            getYears() {
                return Array.from({length: (new Date().getFullYear()+1) - 2020}, (value, index) => 2020 + index).reverse()
            },
            setCategory() {
                let me = this;
                this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + '/activity/category')
                    .then(function (res) {
                        me.category = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            setLevel() {
                let me = this;
                this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + '/activity/level')
                    .then(function (res) {
                        me.level = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            getCategory() {
                return this.category;
            },
            getLevel() {
                return this.level;
            },
            getLevelByMinute(minute) {
                let nowLev = this.level.filter(l => (l.min <= minute && l.max >= minute));
                return nowLev ? nowLev[0] : this.level[0];
            },
            getLevelPercent(minute) {
                return minute ? parseInt((minute / this.getLevelByMinute(minute).max) * 100) : 0;
            },
            getMemberInfo(id) {
                let me = this;
                this.axios.get(process.env.VUE_APP_MEMBER_API_URL + `/${id}`)
                    .then(function (res) {
                        me.$modal.show('MemberInfoModal', {'member': res.data})
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            agoDateFormat(date) {
                return `${moment(date).add(-9, 'h').format('YYYY-MM-DDTHH:mm:ss')}.000Z`;
            },
            afterDateFormat(date) {
                return `${moment(date).add(-9, 'h').format('YYYY-MM-DDTHH:mm:ss')}.000Z`;
            },
            getAgeString(birthday) {
                //console.log(parseInt(birthday/10000))
                let age = parseInt(moment().format('YYYY')) - parseInt(birthday / 10000);
                return age > 9 ? `${parseInt(age / 10)}0 대` : '10세 미만';
            },
            getAge(birthday) {
                //console.log(parseInt(birthday/10000))
                return parseInt(moment().format('YYYY')) - parseInt(birthday / 10000);
            },
            moment() {
                return moment();
            },
            async resizeImg(file, maxSize) {
                let reader = new FileReader();
                let image = new Image();
                let canvas = document.createElement('canvas');

                let dataURItoBlob = function (dataURI) {
                    let bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
                        atob(dataURI.split(',')[1]) :
                        unescape(dataURI.split(',')[1]);
                    let max = bytes.length;
                    let ia = new Uint8Array(max);
                    for (let i = 0; i < max; i++)
                        ia[i] = bytes.charCodeAt(i);
                    return new Blob([ia], {type: 'image/jpeg'});
                };

                let resize = function () {
                    let width = image.width;
                    let height = image.height;
                    if (width > height) {
                        if (width > maxSize) {
                            height *= maxSize / width;
                            width = maxSize;
                        }
                    } else {
                        if (height > maxSize) {
                            width *= maxSize / height;
                            height = maxSize;
                        }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                    let dataUrl = canvas.toDataURL('image/jpeg');
                    return dataURItoBlob(dataUrl);
                }

                return new Promise(function (ok, no) {
                    reader.onload = function (readerEvent) {
                        image.onload = function () {
                            return ok(resize());
                        };
                        image.src = readerEvent.target.result;

                    };
                    reader.readAsDataURL(file);
                });
            },
            async uploadFile(formData, uploadType) {
                return await this.axios.post(process.env.VUE_APP_PUBLIC_API_URL + `/attachments/image/${uploadType}`, formData).then(function (res) {
                    return res.data;
                }).catch(function (error) {
                    console.log(error);
                    return "";
                });
            },
            getSpecialityMap() {
                let me = this;
                this.axios.get(process.env.VUE_APP_MEMBER_API_URL + '/speciality') //JSON.parse(JSON.stringify(this.member))
                    .then(function (res) {
                        me.specialities = res.data;
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            getSpMap() {
                return this.specialities;
            }
        },
        mounted() {
            this.setCategory()
            this.setLevel()
            this.getSpecialityMap()
        },
        created() {
        }
    }
</script>
<style>
    .pages {
        /*min-height: 771px;*/
        margin-top: 40px;
    }
</style>
